module.exports = __webpack_public_path__ + "2efb74b9bf0bc65edcc7ca12e91e8d89.MP3";